import { http } from "@/lib/http";

import type {
  FlowLog,
  FlowLogCreateRequest,
  FlowLogRecord,
  FlowLogRecordsQuery,
  FlowLogRecordsResponse,
  FlowLogUpdateRequest,
} from "./types";

export async function listFlowLogs(): Promise<FlowLog[]> {
  const { data } = await http.get<FlowLog[]>("/network/flow-logs");
  return data;
}

export async function getFlowLog(flowLogId: string): Promise<FlowLog> {
  const { data } = await http.get<FlowLog>(`/network/flow-logs/${flowLogId}`);
  return data;
}

export async function createFlowLog(
  payload: FlowLogCreateRequest,
): Promise<FlowLog> {
  const { data } = await http.post<FlowLog>("/network/flow-logs", payload);
  return data;
}

export async function updateFlowLog(
  flowLogId: string,
  payload: FlowLogUpdateRequest,
): Promise<FlowLog> {
  const { data } = await http.put<FlowLog>(
    `/network/flow-logs/${flowLogId}`,
    payload,
  );
  return data;
}

export async function deleteFlowLog(flowLogId: string): Promise<void> {
  await http.delete(`/network/flow-logs/${flowLogId}`);
}

/** Records in a window. The API answers `[]` (not an error) when central
 *  logging is not configured; accept a bare list as well as the envelope so
 *  either shape renders as "no records". */
export async function listFlowLogRecords(
  flowLogId: string,
  query: FlowLogRecordsQuery,
): Promise<FlowLogRecordsResponse> {
  const { data } = await http.get<FlowLogRecordsResponse | FlowLogRecord[]>(
    `/network/flow-logs/${flowLogId}/records`,
    { params: query },
  );
  if (Array.isArray(data)) {
    return { items: data, since: query.since ?? null, until: query.until ?? null };
  }
  return data;
}
